import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Subject, Subscription } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  switchMap,
  tap,
} from "rxjs/operators";
import { CatalogoRecetarioService } from "app/services/catalogo-recetario.service";
import { Medicamento, Presentacion } from "app/models/medicamento.interface";

export interface MedicamentoSeleccionado {
  external_medication_id: string;
  medication_name: string;
  presentation: string;
}

@Component({
  selector: "app-buscador-medicamentos",
  templateUrl: "./buscador-medicamentos.component.html",
  styleUrls: ["./buscador-medicamentos.component.css"],
})
export class BuscadorMedicamentosComponent implements OnInit, OnDestroy {
  @Output() medicamentoSeleccionado =
    new EventEmitter<MedicamentoSeleccionado>();

  searchTerm = "";
  resultados: Medicamento[] = [];
  buscando = false;
  private searchSubject = new Subject<string>();
  private subscription: Subscription;

  constructor(private catalogoService: CatalogoRecetarioService) {}

  ngOnInit(): void {
    this.subscription = this.searchSubject
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(() => {
          this.buscando = true;
          this.resultados = [];
        }),
        switchMap((term) => this.catalogoService.searchMedicamentos(term)),
      )
      .subscribe({
        next: (results) => {
          this.resultados = results;
          this.buscando = false;
        },
        error: () => {
          this.resultados = [];
          this.buscando = false;
        },
      });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onSearch(): void {
    if (this.searchTerm.trim().length >= 3) {
      this.searchSubject.next(this.searchTerm.trim());
    } else {
      this.resultados = [];
    }
  }

  seleccionarPresentacion(
    medicamento: Medicamento,
    presentacion: Presentacion,
  ): void {
    this.medicamentoSeleccionado.emit({
      external_medication_id: presentacion.externalId,
      medication_name: `${medicamento.name} (${medicamento.genericName})`,
      presentation: `${presentacion.name} - ${presentacion.quantity} ${presentacion.unit}`,
    });
    this.searchTerm = "";
    this.resultados = [];
  }
}
